// removed by extract-text-webpack-plugin
module.exports = {"img":"_3oW7q4UkxaG8eimhHM-iGO"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/LoadModal/LoadModal.scss
 ** module id = 988
 ** module chunks = 0
 **/